import { Form } from 'antd';

import { StepWrapper } from '../../../styles';
import { TranslatedTitle, TranslatedText } from '../components';

import { OnBoardingWeekDaysPicker } from '@/components/Onboarding';
import { SpecificDaysPicker } from '@/components/Planification';
import { Box } from '@/components/Utils';

export const StudyPlanFP = () => {
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="STUDY_PLAN" />
      <Box flexDirection="column">
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="REST_WEEK_DAYS" />
          <Form.Item name={['planification', 'restWeekdays']}>
            <OnBoardingWeekDaysPicker />
          </Form.Item>
        </Box>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="REST_DATES" />
          <Form.Item name={['planification', 'restDates']}>
            <SpecificDaysPicker hideLabel />
          </Form.Item>
        </Box>
      </Box>
    </StepWrapper>
  );
};
